import * as React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@capacit-com/lara-law-shared-ui";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { Switch } from "@capacit-com/lara-law-shared-ui"; // Replace with your Switch component
import { RowData } from "@tanstack/react-table";
import { DataTableFilterProps } from "./data-table-filter-props";

export function DataTableToggleFilter<TData extends RowData>({
  column,
  title = "Toggle Filter",
  options = [],
}: DataTableFilterProps<TData>) {
  const [value, setValue] = React.useState<boolean | undefined>(() =>
    typeof column?.getFilterValue() === "boolean"
      ? (column.getFilterValue() as boolean | undefined)
      : undefined
  );

  const trueOption = options.find((option) => option.booleanValue === true);
  const falseOption = options.find((option) => option.booleanValue === false);

  if (!trueOption || !falseOption) {
    return null;
  }

  const handleToggle = (newValue: boolean) => {
    setValue(newValue);
    let filterValue: unknown = undefined;
    if (newValue === true) {
      filterValue = trueOption?.value;
    } else if (newValue === false) {
      filterValue = falseOption?.value;
    }

    column?.setFilterValue(filterValue);
  };

  const handleClear = () => {
    setValue(undefined);
    column?.setFilterValue(undefined);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 border-dashed">
          {title}
          <span className="ml-2 text-sm font-normal">
            {value === true
              ? trueOption.label
              : value === false
                ? falseOption.label
                : "Begge"}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-4 w-[220px] space-y-4" align="start">
        <h4 className="text-sm font-medium">{title}</h4>
        <div className="flex items-center justify-between space-x-2">
          <span className="text-sm">{falseOption.label}</span>
          <Switch checked={value === true} onCheckedChange={handleToggle} />
          <span className="text-sm">{trueOption.label}</span>
        </div>
        <div className="flex justify-end">
          <Button
            size="sm"
            variant="ghost"
            onClick={handleClear}
            className="text-xs"
          >
            Ryd filter
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
